import { JETTY_URL } from 'service/siwe/constants'
import { siweAuthedFetch } from 'service/siwe/siweFetch'

export const updateUser = async reqBody => {
  try {
    const req = siweAuthedFetch(`${JETTY_URL}/user/upsert`, {
      method: 'PUT',
      mode: 'cors',
      body: JSON.stringify(reqBody),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })

    const res = await req.then(res => res)
    return res
  } catch (err) {
    throw new Error(err)
  }
}
